import { Cart } from '@miles/domain/Store/Models/Cart/Cart'
import useSWR, { SWRConfiguration } from 'swr'
import { GET_CART_SWR_KEY } from 'components/Hook/CartContext'
import { storefrontApiClient } from 'store/clients/storefrontApiClient'

export const useGetCartById = (cartId: string | null | undefined) => {
  const fetcher: () => Promise<Cart | undefined> = async () => {
    if (!cartId) {
      return undefined
    }
    return await storefrontApiClient.getCartById(cartId)
  }

  return useSWR(`${GET_CART_SWR_KEY}/${cartId}`, fetcher)
}

export const useGetRawCartById = (
  cartId: string | null | undefined,
  config?: SWRConfiguration
) => {
  const fetcher = async () => {
    if (!cartId) {
      return undefined
    }
    return await storefrontApiClient.getCartOnlyById(cartId)
  }

  return useSWR(`${GET_CART_SWR_KEY}/${cartId}`, fetcher, config)
}
